import StandardQueryTable from "@/components/StandardQueryTable";
import { PATH_DICTS_UPDATES_DEPARTMENTS } from "@/constants";
import { createDictionaryLabels } from "@/containers/dictionaries/createDictionaryLabels";
import { defaultDictionaryTableFeatures } from "@/containers/dictionaries/defaultDictionaryTableFeatures";
import { Module } from "@/constants";
import { getDictionaryLabels } from "@/containers/dictionaries/getDictionaryLabels";
import { DictionaryConfig } from "@/containers/dictionaries/types";
import DepartmentCreator from "@/modules/departments/components/DepartmentCreator";
import DepartmentEditor from "@/modules/departments/components/DepartmentEditor";
import { readDepartment, writeDepartment } from "@/schemas/department";
import { DepartmentService } from "@/services/department";
import { ReadDepartment, WriteDepartment } from "@/types/department";
import { Component } from "lucide-react";

const id = Module.UpdatesDepartments;
const path = PATH_DICTS_UPDATES_DEPARTMENTS;
const ns = "departments";

const config: DictionaryConfig<ReadDepartment, WriteDepartment> = {
  id,
  ns,
  service: DepartmentService,
  path,
  labels: createDictionaryLabels(ns),
  getLabels: getDictionaryLabels,
  schema: writeDepartment,
  defaultValues: { name: "", description: "" },
  Icon: Component,
  List: () => (
    <StandardQueryTable<ReadDepartment>
      schema={readDepartment}
      name={ns}
      fetchList={DepartmentService.getList}
      pathBuilder={(row) => `${path}/${row.id}`}
      tableFeatures={{
        ...defaultDictionaryTableFeatures,
        exportSettings: { moduleName: Module.UpdatesDepartments },
      }}
    />
  ),
  Creator: DepartmentCreator,
  Editor: DepartmentEditor,
};

export default config;
